import { useCapabilityCitationStore } from '../store/capabilityCitations';
import { validateCitation, checkUrlAccessibility } from '../utils/citationValidator';
import { CapabilityCitation, CitationAuditResult } from '../types/capabilityCitation';

export class CitationAuditService {
  
  static getAuditReport(): CitationAuditResult {
    return useCapabilityCitationStore.getState().getAuditReport();
  }

  static async runFullAudit(): Promise<{
    report: CitationAuditResult;
    details: { capabilityId: string; issues: string[] }[];
  }> {
    const store = useCapabilityCitationStore.getState();
    const citations = store.citations;
    const details: { capabilityId: string; issues: string[] }[] = [];

    for (const citation of citations) {
      const issues: string[] = [];
      
      // 1. Validate Structure & Logic
      const validation = await validateCitation(citation);
      if (!validation.valid) {
        issues.push(`Validation Error: ${validation.reason}`);
      }

      // 2. Check URL Accessibility (Async)
      if (citation.citationURL) {
        const isAccessible = await checkUrlAccessibility(citation.citationURL);
        if (!isAccessible) {
          issues.push(`URL Unreachable: ${citation.citationURL}`);
        }
      } else {
        issues.push("Missing Citation URL");
      }

      if (issues.length > 0) {
        details.push({ capabilityId: citation.capabilityId, issues });
      }
    }

    return {
      report: store.getAuditReport(),
      details
    };
  }

  static exportAuditToCSV(): string {
    const citations = useCapabilityCitationStore.getState().citations;
    const headers = ['Capability ID', 'Name', 'Source', 'Title', 'URL', 'Date', 'Legal Status', 'Verified'];
    const rows = citations.map(c => [
      c.capabilityId,
      `"${c.capabilityName}"`,
      `"${c.citationSource}"`,
      `"${c.citationTitle}"`,
      c.citationURL,
      c.datePublished,
      c.legalStatus,
      c.verified ? 'Yes' : 'No'
    ]);

    return [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
  }
}
